import { API } from '@app/constants';
import { defineHostWithProtocol } from '@app/utils/defineHostWithProtocol/defineHostWithProtocol';

export const openImportTemplateFile = (templateEndpoint: string): void => {
  window.open(`${defineHostWithProtocol({})}${API}${templateEndpoint}`);
};
